import React, { useEffect, useState, useRef } from 'react';
import { Sparklines, SparklinesLine } from 'react-sparklines';
import './PairChart.css';

// Example usage: <PairChart pair="TUSD/Carbon" pairLabel="TUSD/Carbon" />
function PairChart({ pair, pairLabel }) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const initialLoad = useRef(true);
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    let isMounted = true;
    async function fetchHistory() {
      if (initialLoad.current) setLoading(true);
      console.log('[PairChart] Fetching /api/pairs-history for pair:', pair);
      try {
        const res = await fetch(`${API_URL}/api/pairs-history`);
        console.log('[PairChart] Response status:', res.status);
        const data = await res.json();
        console.log('[PairChart] Data received:', data);
        //if (isMounted) {
        //  console.log('[PairChart] Setting history for pair', pair, '->', data[pair]);
        //  setHistory(data[pair] || []);
        //}
        if (isMounted) {
            let historyArr = data[pair];
            let usedReverse = false;
            if (!historyArr) {
                // Try the reverse key if not found
                const [a, b] = pair.split('/');
                const reverseKey = `${b}/${a}`;
                historyArr = data[reverseKey];
                usedReverse = !!historyArr;
                console.log('[PairChart] Reverse lookup for pair', reverseKey, '->', historyArr);
            }
            // If using reverse, invert the price values
            if (usedReverse && Array.isArray(historyArr)) {
                historyArr = historyArr.map(v => (v && v !== 0) ? 1 / v : 0);
            }
            console.log('[PairChart] Setting history for pair', pair, '->', historyArr);
            setHistory(historyArr || []);
        }

      } catch (e) {
        console.error('[PairChart] Error fetching or parsing /api/pairs-history:', e);
        if (isMounted) setHistory([]);
      }
      if (initialLoad.current) {
        setLoading(false);
        initialLoad.current = false;
      }
    }
    fetchHistory();
    // Optionally, poll every 10s for updates
    const interval = setInterval(fetchHistory, 10000);
    return () => { isMounted = false; clearInterval(interval); };
  }, [pair, API_URL]);

  // Only show loading on first mount
  if (loading) return <div className="pair-chart-loading">Loading...</div>;
  // Always show a chart, even if there is no data
  const chartData = history.length ? history : Array(20).fill(0);
  return (
    <div className="pair-chart-container">
      
      <Sparklines data={chartData} height={24} margin={4}>
        <SparklinesLine color="#0074d9" style={{ fill: 'none' }} />
      </Sparklines>
      <div className="pair-chart-label">{pairLabel}</div>
    </div>
  );
}

export default React.memo(PairChart);
